import { ButtonSecondary, cssColorValue, desktopCelloCanon, mobileCello, screenXsMin, spacer4, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { useS4AMastheadContext, } from '../../S4AMastheadProvider';
import { ButtonSecondaryLink, FrodorTextLink } from '../../Link/Link';
import { getInternalHref } from '../utils';
import { login, logout } from '../../../utils/auth';
const UnstyledButton = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: none;
`;
const OutlineButton = styled(ButtonSecondary) `
  background: transparent;
  border: 1px solid ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};

  &:hover {
    background: transparent;
    border: 1px solid
      ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  }

  &&:focus::after {
    border-color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('backgroundBase'); }};
  }
`;
const InvertedButton = styled(ButtonSecondaryLink) `
  background-color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  border: 1px solid ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.background) || cssColorValue('backgroundBase'); }};
  cursor: pointer;

  &:hover {
    border: 1px solid
      ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  }

  &&:focus::after {
    border-color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('backgroundBase'); }};
  }
`;
export const NavBarSideMenuLink2 = styled(UnstyledButton) `
  && {
    color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
    background-color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.background) || cssColorValue('backgroundBase'); }};
    text-decoration: none;
    ${desktopCelloCanon};

    &&:active,
    &&:hover,
    &&:focus {
      box-shadow: none;
      color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      text-decoration: none;
    }

    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: ${spacer4};
    }

    @media (max-width: ${screenXsMin}) {
      ${mobileCello}
    }
  }
`;
export const NavBarSideMenuLink = styled(FrodorTextLink) `
  && {
    color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
    text-decoration: none;
    ${desktopCelloCanon};

    &&:active,
    &&:hover,
    &&:focus {
      box-shadow: none;
      color: ${props => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      text-decoration: none;
    }

    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: ${spacer4};
    }

    @media (max-width: ${screenXsMin}) {
      ${mobileCello}
    }
  }
`;
export const useNavBarActions = ({ colors, container, userState, headerEntry, closeBackdrop, }) => {
    const { trackCat, isFrodor, onLinkClick, clientId, getLoginRedirectUri } = useS4AMastheadContext();
    const isSideMenu = container === 'sidemenu';
    const showLogin = userState === 'loggedOut';
    const showLogout = userState === 'claimed' || userState === 'unclaimed';
    const showDashboard = userState === 'claimed';
    const showClaim = userState === 'unclaimed' || userState === 'loggedOut';
    const loginAction = () => {
        if (!showLogin) {
            return null;
        }
        const track = [trackCat, 'Log In'];
        const loginProps = {
            colors,
            onClick: () => {
                onLinkClick({
                    href: 'https://accounts.spotify.com/login',
                    trackingAttributes: track,
                    external: true,
                });
                login(clientId, getLoginRedirectUri());
            },
            track: track,
            children: headerEntry.fields.loginButtonText,
        };
        if (isSideMenu) {
            return (React.createElement(NavBarSideMenuLink2, Object.assign({ "data-testid": "navigation-sidemenu-login" }, loginProps)));
        }
        return (React.createElement(OutlineButton, Object.assign({ size: "small", "data-testid": "root-login" }, loginProps)));
    };
    const logoutAction = () => {
        if (!showLogout) {
            return null;
        }
        const track = [trackCat, 'Log Out'];
        const logoutProps = {
            colors,
            onClick: () => {
                onLinkClick({
                    href: 'https://accounts.spotify.com/logout',
                    trackingAttributes: track,
                    external: true,
                });
                logout(clientId);
            },
            track: track,
            children: headerEntry.fields.logoutButtonText,
        };
        if (isSideMenu) {
            return (React.createElement(NavBarSideMenuLink2, Object.assign({ "data-testid": "navigation-sidemenu-logout" }, logoutProps)));
        }
        return (React.createElement(OutlineButton, Object.assign({ size: "small", "data-testid": "root-logout" }, logoutProps), headerEntry.fields.logoutButtonText));
    };
    const claimAction = () => {
        if (!showClaim) {
            return null;
        }
        const href = getInternalHref('/claim', isFrodor);
        const track = [trackCat, `Get Access (${userState})`];
        if (isSideMenu) {
            return (React.createElement(NavBarSideMenuLink, { colors: colors, dataTestId: "navigation-sidemenu-claim", href: href, track: track, onClick: closeBackdrop }, headerEntry.fields.getAccessText));
        }
        return (React.createElement(InvertedButton, { size: "small", colors: colors, dataTestId: "navigation-claim", href: href, track: track }, headerEntry.fields.getAccessText));
    };
    const dashboardAction = () => {
        if (!showDashboard) {
            return null;
        }
        const href = getInternalHref('/c', isFrodor);
        const track = [trackCat, 'Dashboard'];
        if (isSideMenu) {
            return (React.createElement(NavBarSideMenuLink, { colors: colors, dataTestId: "navigation-sidemenu-dashboard", href: href, track: track, onClick: closeBackdrop }, headerEntry.fields.dashboardText));
        }
        return (React.createElement(InvertedButton, { size: "small", colors: colors, dataTestId: "navigation-dashboard", href: href, track: track }, headerEntry.fields.dashboardText));
    };
    return {
        loginAction: loginAction(),
        logoutAction: logoutAction(),
        claimAction: claimAction(),
        dashboardAction: dashboardAction(),
    };
};
//# sourceMappingURL=useNavBarActions.js.map